module.exports = __webpack_public_path__ + "img/1557614089961807873.2715a983.png";